// Vendor imports
const { combineReducers } = require('redux-immutable')
// Sibling imports
const RootRecord = require('./record')

const reducers = {
  // Common state
  ...require('client-v2/common/state/reducers'),
  // Common containers
  articleProfileModal: require('client-v2/common/containers/article-profile/state/modal-reducer'),
  authModal: require('client-v2/common/containers/auth-modal/reducer'),
  collectionSelectModal: require('client-v2/common/containers/collection-select-modal/reducer'),
  confirmModal: require('client-v2/common/containers/confirm-modal/reducer'),
  lightweightEngagementTutorial: require('client-v2/common/containers/lightweight-engagement/containers/tutorial/reducer'),
  searchForm: require('client-v2/common/containers/search-form/reducer'),
  shareModal: require('client-v2/common/containers/share-modal/reducer'),
  toasts: require('client-v2/common/containers/toasts/reducer'),
  tooltips: require('client-v2/common/containers/tooltips/reducer'),
  // Entry containers
  feed: require('client-v2/user-profile/containers/feed/reducer'),
  profileUser: require('client-v2/user-profile/containers/profile-user/reducer'),
  profileUserStats: require('client-v2/user-profile/containers/profile-user-stats/reducer')
}

module.exports = combineReducers(
  reducers,
  () => new RootRecord()
)
